import { StampAnnotation } from '@st/sdk'
import { CrossReferencesToolState } from '~/st-doc-viewer/annotations'
import { findMatchingTemplate } from './templates'

export function copyToolState(annotation: StampAnnotation): CrossReferencesToolState {
  const matchingTemplate = findMatchingTemplate(annotation)

  return {
    name: 'cross_references',
    settings: { templateId: matchingTemplate?.id }
  }
}
